import api from '../../api';

const initialState = () => {
  return {
    customer: '',
    alert: {
      show: false,
      variant: 'success',
      message: ''
    }
  };
};

export default {
  state: initialState(),
  getters: {
    getCustomer(state) {
      return state.customer;
    },
    isCustomer(state) {
      return state.customer ? true : false;
    },
    showAlert(state) {
      return state.alert.show;
    },
    alert(state) {
      return state.alert;
    }
  },
  mutations: {
    setCustomer(state, value) {
      state.customer = value;
    },
    setAlert(state, value) {
      state.alert.show = value.show;
      state.alert.variant = value.variant;
      state.alert.message = value.message;
    },
    reset(state) {
      const s = initialState();
      Object.keys(s).forEach((key) => {
        state[key] = s[key];
      });
    }
  },
  actions: {
    async getUserValid({ commit }, payload) {
      commit('reset');
      const res = await api.getUserValid(payload);
      commit('setCustomer', res.data);
      if (res.status) {
        const value = {
          show: true,
          variant: 'success',
          message: 'Usuario registrado'
        };
        commit('setAlert', value);
      } else {
        const value = {
          show: true,
          variant: 'info',
          message: 'Registar usuario'
        };
        commit('setAlert', value);
      }
    },
    async createUser({ commit }, form) {
      commit('reset');
      const res = await api.createUser(form);
      commit('setCustomer', res.data);
      if (res.status) {
        const value = {
          show: true,
          variant: 'success',
          message: 'Usuario registrado'
        };
        commit('setAlert', value);
      } else {
        const value = {
          show: true,
          variant: 'danger',
          message: 'El usuario ya existe'
        };
        commit('setAlert', value);
      }
    }
  }
};
